import { useFormik } from "formik";
import React, { useEffect } from "react";
import toast from "react-hot-toast";
import { Col, Container, Form, FormGroup, Label, Row } from "reactstrap";
import { Button, InputField } from "src/components";
import { setFromErrors } from "src/helpers";
import { useInsDutiesEntryMutation } from "src/rtk/features/instituteAndDepartmentRegistration/instituteAndDepartmentRegistrationApi";
import * as Yup from 'yup';

interface TraineeWorkAttachmentProps {
    departmentId?: string;
    recordOfTraineeWorkAttachmentToEdit?: InsDutiesList;
    setModalShow?: any;
}

const initialValues: InsDutiesEntry = {
    ins_training_id: '',
    form_b_department_id: '',
    duties: '',
    frequency_or_week: '',
    unit: '',
    type: '',
};

const TraineeWorkAttachmentModal = (props: TraineeWorkAttachmentProps) => {
    const { departmentId, recordOfTraineeWorkAttachmentToEdit, setModalShow } = props;

    const [traineeWorkAttachmentEntry, { data: traineeWorkAttachmentEntryData, isSuccess: isTraineeWorkAttachmentEntryDataSuccess, isLoading: isTraineeWorkAttachmentEntryDataLoading, isError: isTraineeWorkAttachmentEntryDataError, error: traineeWorkAttachmentEntryDataError }] =
        useInsDutiesEntryMutation();

    const err: CustomError = traineeWorkAttachmentEntryDataError as CustomError;

    const formik = useFormik({
        initialValues,
        validationSchema: Yup.object({}),

        onSubmit: (values: InsDutiesEntry) => {
            console.log(values);
            values.form_b_department_id = departmentId;
            values.type = 'laboratory_work_attachment';
            values.unit = 'week';
            traineeWorkAttachmentEntry(values);
        },
    });

    const {
        handleSubmit,
        getFieldProps,
        values,
        handleChange,
        handleBlur,
        touched,
        errors,
        resetForm,
        setValues,
        setErrors,
        setFieldValue,
    } = formik;

    const handleFormReset = () => {
        resetForm();
    };

    useEffect(() => {
        if (recordOfTraineeWorkAttachmentToEdit?.id) {
            setValues({
                ins_training_id: recordOfTraineeWorkAttachmentToEdit?.id,
                form_b_department_id: recordOfTraineeWorkAttachmentToEdit?.form_b_department_id,
                duties: recordOfTraineeWorkAttachmentToEdit?.duties,
                frequency_or_week: recordOfTraineeWorkAttachmentToEdit?.frequency_or_week,
                unit: recordOfTraineeWorkAttachmentToEdit?.unit,
                type: recordOfTraineeWorkAttachmentToEdit?.type,
            });
        }
    }, []);

    useEffect(() => {
        if (isTraineeWorkAttachmentEntryDataSuccess) {
            handleFormReset();
            toast.success('Trainee\'s Clinical/Laboratory work attachment saved successfully');
            setModalShow(false);
        }
        if (isTraineeWorkAttachmentEntryDataError) {
            Object.entries(err?.data).forEach((entry: any) => {
                entry[1]?.forEach((message: any) => {
                    toast.error(message);
                });
            });
            setFromErrors(err.data, setErrors);
        }
    }, [isTraineeWorkAttachmentEntryDataSuccess, isTraineeWorkAttachmentEntryDataError]);

    return (
        <React.Fragment>
            <Container fluid>
                <Row>
                    <Col lg={12}>
                        <Form
                            autoComplete="off"
                            className="custom-form"
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleSubmit();
                            }}
                            onReset={(e) => {
                                e.preventDefault();
                                handleFormReset();
                            }}
                        >
                            <Row>
                                <Col sm={12} md={6}>
                                    <FormGroup className="mb-3">
                                        <Label for="duties">Duties</Label>
                                        <InputField
                                            type="select"
                                            options={[
                                                { label: 'OPD care', value: 'OPD care' },
                                                { label: 'In-patient care', value: 'In-patient care' },
                                                { label: 'History Taking', value: 'History Taking' },
                                                { label: 'Follow up', value: 'Follow up' },
                                                { label: 'Emergency', value: 'Emergency' },
                                                { label: 'OT', value: 'OT' },
                                                { label: 'ICU', value: 'ICU' },
                                                { label: 'CCU', value: 'CCU' },
                                                { label: 'Post Operative care', value: 'Post Operative care' },
                                                { label: 'Laboratory work', value: 'Laboratory work' }
                                            ]}
                                            placeholder=""
                                            {...getFieldProps('duties')}
                                        />
                                    </FormGroup>
                                </Col>

                                <Col sm={12} md={6}>
                                    <FormGroup className="mb-3">
                                        <Label for="frequency_or_week">Frequency/Week</Label>
                                        <InputField
                                            type="text"
                                            placeholder=""
                                            {...getFieldProps('frequency_or_week')}
                                        />
                                    </FormGroup>
                                </Col>

                                <Col sm={12} className="mt-3">
                                    <FormGroup className="mb-3 text-center">
                                        <Button
                                            type="reset"
                                            text="Reset"
                                            className="btn btn-warning me-2"
                                        ></Button>
                                        <Button
                                            type="submit"
                                            text="Save"
                                            className="btn btn-success me-2"
                                            disabled={isTraineeWorkAttachmentEntryDataLoading}
                                        ></Button>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    );
};

export default TraineeWorkAttachmentModal;